import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

const AuthLayout = () => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  const navigate = useNavigate();
  useEffect(() => {
    if (userData) {
      const defaultPath = userData.role === "USER" ? "/app/my-photos" : "/app/dashboard";
      navigate(defaultPath, { replace: true });
    }
  }, [userData, navigate]);

  return !userData && <Outlet />;
};
export default AuthLayout;
